import type { Storage } from "@/types";
import uniqBy from "lodash/uniqBy";
import { create } from "zustand";

interface StorageStoreState {
	storages: Storage[];
}

interface StorageStoreActions {
	setStorages: (storages: Storage[]) => Promise<Storage[]>;
	removeStorage: (storage: Storage) => Promise<number>;
	resetStorages: () => void;
}

type StorageStore = StorageStoreState & StorageStoreActions;

const initialState: StorageStoreState = {
	storages: [],
};

export const useStorage = create<StorageStore>((set, get) => ({
	...initialState,
	setStorages: (storages) => {
		return new Promise((resolve) => {
			const { storages: currentStorages } = get();
			const newStorages = uniqBy([...currentStorages, ...storages], "id");
			set({ storages: newStorages });
			resolve(newStorages);
		});
	},
	removeStorage: (storage) => {
		return new Promise((resolve) => {
			const { storages } = get();
			const newStorages = storages.filter((i) => i.id !== storage.id);
			set({ storages: newStorages });
			resolve(newStorages.length);
		});
	},
	resetStorages: () => set(initialState),
}));
